(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-avaliar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-mva]');
    if (!raiz || raiz.__mva) return;
    raiz.__mva = true;

    var API = (raiz.getAttribute('data-mva-api') || '').replace(/\/+$/, '');
    var SITEKEY = raiz.getAttribute('data-mva-sitekey');
    var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var P = new URLSearchParams(location.search);
    var passo1 = raiz.querySelector('[data-mva-passo="1"]');
    var passo2 = raiz.querySelector('[data-mva-passo="2"]');
    var ESC = { handle: null, titulo: '', url: '' };
    var CHAVE = 'mva-feitos';

    /* cookies já avaliados neste aparelho ganham o selo "Avaliado" na grade */
    function feitos() { try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch (e) { return []; } }
    function pintaFeitos() {
      var f = feitos();
      raiz.querySelectorAll('[data-mva-escolhe]').forEach(function (b) {
        b.querySelector('[data-mva-feito]').hidden = f.indexOf(b.getAttribute('data-mva-escolhe')) < 0;
      });
    }
    function marcarFeito(h) {
      var f = feitos();
      if (f.indexOf(h) < 0) f.push(h);
      try { localStorage.setItem(CHAVE, JSON.stringify(f)); } catch (e) {}
      pintaFeitos();
    }

    /* ================= formulário ================= */
    var F = raiz.querySelector('[data-mva-f]');
    var forma = F.querySelector('[data-mva-forma]');
    var obrigado = F.querySelector('[data-mva-obrigado]');
    var erroEl = F.querySelector('[data-mva-erro]');
    var previas = F.querySelector('[data-mva-previas]');
    var entrada = F.querySelector('[data-mva-arquivos]');
    var solta = F.querySelector('[data-mva-solta]');
    var prog = F.querySelector('[data-mva-prog]');
    var enviarB = F.querySelector('[data-mva-enviar]');
    var enviando = false;
    var arquivos = []; /* {id, tipo, blob, previa, l, a, d, capa, pronto, erro, el} */
    var robo = { id: null, pedido: null };


    /* ---- Turnstile (anti-robô do Cloudflare), carregado só quando o painel abre ---- */
    function prepararRobo() {
      if (!SITEKEY || robo.id !== null || robo.pedido) return;
      robo.pedido = new Promise(function (ok, falha) {
        if (window.turnstile) return ok();
        window.mvaTurnstile = ok;
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=mvaTurnstile';
        s.async = true; s.defer = true; s.onerror = falha;
        document.head.appendChild(s);
      }).then(function () {
        robo.id = turnstile.render(F.querySelector('[data-mva-robo]'), {
          sitekey: SITEKEY, language: 'pt-br', theme: 'light', size: 'flexible', appearance: 'interaction-only',
          'response-field': false
        });
      }).catch(function () { robo.pedido = null; });
    }
    function tokenRobo() {
      return new Promise(function (ok) {
        if (!window.turnstile || robo.id === null) return ok('');
        var t = turnstile.getResponse(robo.id);
        if (t) return ok(t);
        /* ainda resolvendo: espera até 12 s */
        var n = 0, iv = setInterval(function () {
          t = turnstile.getResponse(robo.id);
          if (t || ++n > 48) { clearInterval(iv); ok(t || ''); }
        }, 250);
      });
    }

    /* ---- estrelas grandes ---- */
    var ROT = ['', 'Não gostei', 'Poderia ser melhor', 'Ok', 'Gostei', 'Amei!'];
    var labels = F.querySelectorAll('.mva-f__estrelas label');
    var rotNota = F.querySelector('[data-mva-nota-rot]');
    function notaAtual() { var c = forma.querySelector('input[name="nota"]:checked'); return c ? Number(c.value) : 0; }
    function pintaEstrelas(n, provisorio) {
      labels.forEach(function (l, i) { l.classList.toggle('mva-acesa', i < n); });
      rotNota.textContent = n ? ROT[n] : 'Toque nas estrelas';
      if (!provisorio) F.querySelector('.mva-f__notas').classList.remove('mva-ruim');
    }
    forma.querySelectorAll('input[name="nota"]').forEach(function (r) {
      r.addEventListener('change', function () { pintaEstrelas(notaAtual()); });
    });
    labels.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) pintaEstrelas(i + 1, true); });
      l.addEventListener('mouseleave', function () { pintaEstrelas(notaAtual(), true); });
    });

    var texto = forma.querySelector('textarea[name="texto"]');
    var conta = F.querySelector('[data-mva-conta]');
    texto.addEventListener('input', function () { conta.textContent = texto.value.length + '/2000'; });
    forma.addEventListener('input', function (e) {
      var c = e.target.closest('.mva-f__campo, .mva-f__ok');
      if (c) c.classList.remove('mva-ruim');
    });

    /* ---- fotos e vídeo: comprimidos NO NAVEGADOR antes de subir ---- */
    var MAX_FOTOS = 5, MAX_VIDEO_MB = 25, MAX_VIDEO_S = 30, LADO = 1600;
    function blobDeCanvas(c, q) { return new Promise(function (ok) { c.toBlob(function (b) { ok(b); }, 'image/jpeg', q); }); }
    function carregarImagem(arq) {
      if (window.createImageBitmap) {
        return createImageBitmap(arq, { imageOrientation: 'from-image' }).catch(function () { return carregarImg(arq); });
      }
      return carregarImg(arq);
    }
    function carregarImg(arq) {
      return new Promise(function (ok, falha) {
        var u = URL.createObjectURL(arq), im = new Image();
        im.onload = function () { ok(im); };
        im.onerror = function () { URL.revokeObjectURL(u); falha(new Error('imagem')); };
        im.src = u;
      });
    }
    function comprimirFoto(arq) {
      return carregarImagem(arq).then(function (im) {
        var w = im.width || im.naturalWidth, h = im.height || im.naturalHeight;
        var k = Math.min(1, LADO / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        var g = c.getContext('2d');
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
        g.drawImage(im, 0, 0, c.width, c.height);
        if (im.close) im.close();
        return blobDeCanvas(c, 0.82).then(function (b) { return { blob: b, l: c.width, a: c.height }; });
      });
    }
    function lerVideo(arq) {
      return new Promise(function (ok, falha) {
        var v = document.createElement('video'), u = URL.createObjectURL(arq), feito = false;
        v.muted = true; v.playsInline = true; v.preload = 'metadata'; v.src = u;
        var fim = function (res) { if (feito) return; feito = true; ok(res); };
        v.onerror = function () { falha(new Error('Esse vídeo não abriu aqui. Tente MP4 ou MOV.')); };
        v.onloadedmetadata = function () {
          var d = v.duration, info = { d: isFinite(d) ? d : 0, l: v.videoWidth, a: v.videoHeight, previa: u, capa: null };
          if (info.d > MAX_VIDEO_S + 1) { falha(new Error('O vídeo tem ' + Math.round(info.d) + ' s. O máximo é ' + MAX_VIDEO_S + ' s.')); return; }
          v.onseeked = function () {
            try {
              var k = Math.min(1, 960 / Math.max(v.videoWidth, v.videoHeight));
              var c = document.createElement('canvas');
              c.width = Math.round(v.videoWidth * k); c.height = Math.round(v.videoHeight * k);
              c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
              blobDeCanvas(c, 0.8).then(function (b) { info.capa = b; fim(info); });
            } catch (e) { fim(info); }
          };
          try { v.currentTime = Math.min(1, (info.d || 2) / 2); } catch (e) { fim(info); }
          setTimeout(function () { fim(info); }, 4000);
        };
      });
    }

    function desenhaPrevia(item) {
      var li = document.createElement('li');
      li.className = 'mva-pv mva-pv--carrega';
      li.innerHTML = '<button class="mva-pv__x" type="button" aria-label="Tirar este arquivo"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (item.tipo === 'video' ? '<span class="mva-pv__tag">vídeo</span>' : '') +
        '<span class="mva-pv__barra" hidden><i></i></span>';
      li.querySelector('.mva-pv__x').addEventListener('click', function () {
        if (enviando) return;
        arquivos = arquivos.filter(function (x) { return x !== item; });
        li.remove();
        if (item.previaUrl) URL.revokeObjectURL(item.previaUrl);
      });
      item.el = li;
      previas.appendChild(li);
    }
    function mostraPrevia(item, url) {
      item.el.classList.remove('mva-pv--carrega');
      var img = document.createElement('img');
      img.alt = ''; img.src = url;
      item.el.insertBefore(img, item.el.firstChild);
    }
    function avisoArquivo(msg) {
      var p = F.querySelector('.mva-f__msg');
      if (!p) { p = document.createElement('p'); p.className = 'mva-f__msg'; previas.after(p); }
      p.textContent = msg;
      clearTimeout(avisoArquivo.t);
      avisoArquivo.t = setTimeout(function () { p.remove(); }, 6000);
    }
    function adicionar(lista) {
      Array.prototype.forEach.call(lista, function (arq) {
        var fotos = arquivos.filter(function (x) { return x.tipo === 'foto'; }).length;
        var videos = arquivos.filter(function (x) { return x.tipo === 'video'; }).length;
        if (/^video\//.test(arq.type) || /\.(mov|mp4|m4v|webm)$/i.test(arq.name)) {
          if (videos >= 1) return avisoArquivo('Só dá para mandar 1 vídeo.');
          if (arq.size > MAX_VIDEO_MB * 1048576) return avisoArquivo('O vídeo tem ' + Math.round(arq.size / 1048576) + ' MB. O máximo é ' + MAX_VIDEO_MB + ' MB. Tente um trecho menor.');
          var it = { tipo: 'video', blob: arq, pronto: false };
          arquivos.push(it); desenhaPrevia(it);
          lerVideo(arq).then(function (info) {
            it.d = info.d; it.l = info.l; it.a = info.a; it.capa = info.capa; it.previaUrl = info.previa; it.pronto = true;
            if (info.capa) mostraPrevia(it, URL.createObjectURL(info.capa));
            else { it.el.classList.remove('mva-pv--carrega'); it.el.insertAdjacentHTML('afterbegin', '<video src="' + info.previa + '#t=0.5" muted playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover"></video>'); }
          }).catch(function (e) {
            arquivos = arquivos.filter(function (x) { return x !== it; }); it.el.remove(); avisoArquivo(e.message);
          });
        } else if (/^image\//.test(arq.type) || /\.(jpe?g|png|webp|heic|heif|gif)$/i.test(arq.name)) {
          if (fotos >= MAX_FOTOS) return avisoArquivo('No máximo ' + MAX_FOTOS + ' fotos.');
          var f = { tipo: 'foto', pronto: false };
          arquivos.push(f); desenhaPrevia(f);
          comprimirFoto(arq).then(function (r) {
            f.blob = r.blob; f.l = r.l; f.a = r.a; f.pronto = true;
            f.previaUrl = URL.createObjectURL(r.blob);
            mostraPrevia(f, f.previaUrl);
          }).catch(function () {
            arquivos = arquivos.filter(function (x) { return x !== f; }); f.el.remove();
            avisoArquivo('Não conseguimos abrir “' + arq.name + '”. Envie em JPG ou PNG.');
          });
        } else {
          avisoArquivo('“' + arq.name + '” não é foto nem vídeo.');
        }
      });
    }
    function limparArquivos() {
      arquivos.forEach(function (x) { if (x.previaUrl) URL.revokeObjectURL(x.previaUrl); });
      arquivos = []; previas.innerHTML = '';
    }
    entrada.addEventListener('change', function () { adicionar(entrada.files); entrada.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.add('mva-sobre'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.remove('mva-sobre'); });
    });
    solta.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) adicionar(e.dataTransfer.files); });

    /* ---- validação ---- */
    function marca(el) { var c = el.closest('.mva-f__campo, .mva-f__ok, .mva-f__notas'); if (c) c.classList.add('mva-ruim'); }
    function erro(msg, el) {
      erroEl.textContent = msg; erroEl.hidden = false;
      if (el) { marca(el); el.focus({ preventScroll: true }); (el.closest('.mva-f__campo, .mva-f__ok, .mva-f__notas') || el).scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' }); }
    }
    function validar() {
      erroEl.hidden = true;
      var el = forma.elements;
      if (!notaAtual()) { F.querySelector('.mva-f__notas').classList.add('mva-ruim'); erro('Escolha de 1 a 5 estrelas.', forma.querySelector('input[name="nota"]')); return false; }
      if (el.texto.value.trim().length < 10) { erro('Conte um pouco mais na sua avaliação (mínimo de 10 letras).', el.texto); return false; }
      if (el.nome.value.trim().length < 2) { erro('Diga seu nome.', el.nome); return false; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.email.value.trim())) { erro('Confira o e-mail.', el.email); return false; }
      if (!el.consentimento.checked) { erro('Para publicar, precisamos do seu de acordo.', el.consentimento); return false; }
      if (arquivos.some(function (x) { return !x.pronto; })) { erro('Espere as fotos terminarem de carregar.'); return false; }
      return true;
    }

    /* ---- envio ---- */
    function postar(caminho, dados) {
      return fetch(API + caminho, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dados) })
        .then(function (r) { return r.json().catch(function () { return { ok: false, erro: 'Resposta inesperada (' + r.status + ').' }; }); });
    }
    function subir(bilhete, item, blob, tipo, extra, aoProgresso) {
      return new Promise(function (ok, falha) {
        var q = 'bilhete=' + bilhete + '&tipo=' + tipo;
        Object.keys(extra).forEach(function (k) { if (extra[k] != null) q += '&' + k + '=' + encodeURIComponent(extra[k]); });
        var x = new XMLHttpRequest();
        x.open('PUT', API + '/v1/midia?' + q);
        x.setRequestHeader('Content-Type', blob.type || 'application/octet-stream');
        x.upload.onprogress = function (e) { if (e.lengthComputable) aoProgresso(e.loaded); };
        x.onload = function () {
          var d = {}; try { d = JSON.parse(x.responseText); } catch (e) {}
          if (x.status === 200 && d.ok) ok(d); else falha(new Error(d.erro || 'falha ao enviar arquivo'));
        };
        x.onerror = function () { falha(new Error('A conexão caiu no meio do envio.')); };
        x.send(blob);
      });
    }
    function estadoEnvio(ligado, texto) {
      enviando = ligado;
      enviarB.disabled = ligado;
      prog.hidden = !ligado;
      if (texto) prog.querySelector('span').textContent = texto;
      forma.querySelectorAll('input, textarea').forEach(function (i) { i.readOnly = ligado; });
    }
    function progresso(p) { prog.querySelector('i').style.width = Math.round(p * 100) + '%'; }

    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando || !validar()) return;
      var el = forma.elements;
      estadoEnvio(true, 'Conferindo…');
      progresso(0.03);
      var paras = Array.prototype.map.call(forma.querySelectorAll('input[name="para"]:checked'), function (c) { return c.value; });
      tokenRobo().then(function (tk) {
        if (!tk && SITEKEY) throw new Error('Confirme que você não é um robô (a caixinha acima do botão) e tente de novo.');
        return postar('/v1/envio', { turnstile: tk, produto: ESC.handle, site: forma.elements.site.value });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        var bilhete = d.bilhete;
        var fila = [];
        arquivos.forEach(function (it) {
          fila.push({ it: it, blob: it.blob, tipo: it.tipo, extra: { l: it.l, a: it.a, d: it.d ? it.d.toFixed(1) : null } });
          if (it.tipo === 'video' && it.capa) fila.push({ it: it, blob: it.capa, tipo: 'capa', extra: { l: it.l, a: it.a } });
        });
        var total = fila.reduce(function (s, f) { return s + f.blob.size; }, 0) || 1, feito = 0, ids = [];
        var seq = Promise.resolve();
        fila.forEach(function (f, k) {
          seq = seq.then(function () {
            estadoEnvio(true, 'Enviando ' + (f.tipo === 'video' ? 'o vídeo' : f.tipo === 'capa' ? 'a capa do vídeo' : 'foto') + '… ');
            var barra = f.it.el.querySelector('.mva-pv__barra');
            if (f.tipo !== 'capa') barra.hidden = false;
            if (f.tipo === 'capa') f.extra.capa_de = f.it.idRemoto;
            return subir(bilhete, f.it, f.blob, f.tipo, f.extra, function (n) {
              if (f.tipo !== 'capa') barra.querySelector('i').style.width = Math.round(n / f.blob.size * 100) + '%';
              progresso(0.05 + 0.85 * (feito + n) / total);
            }).then(function (r) {
              feito += f.blob.size;
              if (f.tipo === 'capa') return;
              f.it.idRemoto = r.id; ids.push(r.id);
              barra.hidden = true; f.it.el.classList.add('mva-pv--ok');
            });
          });
        });
        return seq.then(function () {
          estadoEnvio(true, 'Finalizando…');
          progresso(0.94);
          return postar('/v1/avaliacoes', {
            bilhete: bilhete, produto: ESC.handle, produto_titulo: ESC.titulo, nota: notaAtual(),
            titulo: el.titulo.value, texto: el.texto.value, nome: el.nome.value, email: el.email.value,
            cidade: el.cidade.value, pedido: el.pedido.value, para: paras, midias: ids, consentimento: el.consentimento.checked
          });
        });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        progresso(1);
        estadoEnvio(false);
        forma.hidden = true;
        obrigado.hidden = false;
        obrigado.focus({ preventScroll: true });
        marcarFeito(ESC.handle);
        obrigado.scrollIntoView({ block: 'start', behavior: reduz ? 'auto' : 'smooth' });
      }).catch(function (err) {
        estadoEnvio(false);
        erro(err.message || 'Não deu para enviar agora. Tente de novo.');
        erroEl.scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' });
        if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
      });
    });



    /* ================= passos ================= */
    var imgTopo = raiz.querySelector('[data-mva-f-img]');
    var nomeTopo = raiz.querySelector('[data-mva-f-nome]');
    var trilha = raiz.querySelectorAll('[data-mva-t]');
    function mostra(n) {
      passo1.hidden = n !== 1;
      passo2.hidden = n !== 2;
      trilha.forEach(function (t) { t.classList.toggle('is-on', Number(t.getAttribute('data-mva-t')) === n); });
    }
    function rolaPara(el) {
      var top = el.getBoundingClientRect().top + window.scrollY - ((parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80) + 12);
      window.scrollTo({ top: Math.max(0, top), behavior: reduz ? 'auto' : 'smooth' });
    }
    function limpaForm() {
      forma.reset(); limparArquivos(); pintaEstrelas(0); erroEl.hidden = true;
      conta.textContent = '0/2000';
      obrigado.hidden = true; forma.hidden = false;
      preenche();
      if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
    }
    function escolher(botao, empurra) {
      if (enviando) return;
      ESC = { handle: botao.getAttribute('data-mva-escolhe'), titulo: botao.getAttribute('data-mva-titulo'), url: botao.getAttribute('data-mva-url') };
      var img = botao.getAttribute('data-mva-img');
      imgTopo.hidden = !img; if (img) imgTopo.src = img;
      nomeTopo.textContent = ESC.titulo;
      raiz.querySelector('[data-mva-ver]').href = ESC.url + '#mk-avaliacoes';
      if (!obrigado.hidden) limpaForm();
      mostra(2);
      prepararRobo();
      if (empurra) {
        P.set('produto', ESC.handle);
        try { history.pushState({ mva: ESC.handle }, '', location.pathname + '?' + P.toString()); } catch (e) {}
      }
      rolaPara(raiz.querySelector('[data-mva-f]'));
      setTimeout(function () { raiz.querySelector('#mva-f-tit').focus({ preventScroll: true }); }, reduz ? 0 : 350);
    }
    function voltar(empurra) {
      if (enviando) return;
      if (!obrigado.hidden) limpaForm();
      mostra(1);
      pintaFeitos();
      if (empurra) {
        P.delete('produto');
        var q = P.toString();
        try { history.pushState({ mva: null }, '', location.pathname + (q ? '?' + q : '')); } catch (e) {}
      }
      rolaPara(raiz.querySelector('.mva-cab'));
    }
    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mva-escolhe]');
      if (b) { escolher(b, true); return; }
      if (e.target.closest('[data-mva-trocar]') || e.target.closest('[data-mva-outro]')) voltar(true);
    });
    window.addEventListener('popstate', function () {
      var h = new URLSearchParams(location.search).get('produto');
      var b = h && raiz.querySelector('[data-mva-escolhe="' + CSS.escape(h) + '"]');
      if (b) escolher(b, false); else voltar(false);
    });

    /* dados que vieram no link (WhatsApp / e-mail) */
    function preenche() {
      var el = forma.elements;
      [['nome', 'nome'], ['email', 'email'], ['pedido', 'pedido'], ['cidade', 'cidade']].forEach(function (par) {
        var v = (P.get(par[0]) || '').trim();
        if (v && !el[par[1]].value) el[par[1]].value = v.replace(/^#/, '').slice(0, Number(el[par[1]].maxLength) || 120);
      });
    }
    preenche();
    pintaFeitos();
    var inicial = P.get('produto');
    var bIni = inicial && raiz.querySelector('[data-mva-escolhe="' + CSS.escape(inicial) + '"]');
    if (bIni) {
      try { history.replaceState({ mva: inicial }, '', location.href); } catch (e) {}
      escolher(bIni, false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-pdp-avaliacoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-mav]');
    if (!raiz || raiz.__mav) return;
    raiz.__mav = true;

    /* ================= abas (Avaliações / Perguntas) ================= */
    var abas = raiz.querySelectorAll('[data-mav-aba]');
    var paineis = raiz.querySelectorAll('[data-mav-painel]');
    function abrirAba(alvo) {
      abas.forEach(function (o) {
        var on = o.getAttribute('data-mav-aba') === alvo;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      paineis.forEach(function (p) {
        var on = p.getAttribute('data-mav-painel') === alvo;
        p.classList.toggle('is-on', on);
        p.hidden = !on;
      });
    }
    abas.forEach(function (b) { b.addEventListener('click', function () { abrirAba(b.getAttribute('data-mav-aba')); }); });

    /* ================= revelação do título ================= */
    var rvs = raiz.querySelectorAll('[data-mav-rv]');
    if ('IntersectionObserver' in window) {
      var obsRv = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-vis'); obsRv.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      rvs.forEach(function (e) { obsRv.observe(e); });
    } else rvs.forEach(function (e) { e.classList.add('is-vis'); });

    /* ================= base ================= */
    var API = (raiz.getAttribute('data-mav-api') || '').replace(/\/+$/, '');
    var PRODUTO = raiz.getAttribute('data-mav-produto');
    var SITEKEY = raiz.getAttribute('data-mav-sitekey');
    var TESTE = /[?&]avaliacoes=teste\b/.test(location.search);
    var DADOS = {};
    try { DADOS = JSON.parse(raiz.querySelector('[data-mav-dados]').textContent); } catch (e) {}
    var corpo = raiz.querySelector('[data-mav-corpo]');
    var PARA = { 'para-mim': 'Comi sozinha', presente: 'Foi presente', familia: 'Dividi com a família', trabalho: 'Levei pro trabalho', festa: 'Festa ou visita', 'data-especial': 'Data especial' };
    var ORDENS = [['recentes', 'Mais recentes'], ['uteis', 'Mais úteis'], ['melhores', 'Melhores notas'], ['piores', 'Piores notas']];
    var reduz = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (TESTE) raiz.querySelector('[data-mav-teste]').hidden = false;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function num(n) { return String(n).replace('.', ','); }
    var CAM = 'M10 1.6l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6 4.8 17.5 6 11.7 1.6 7.7l5.9-.7Z';
    function svg5() { var s = ''; for (var i = 0; i < 5; i++) s += '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg>'; return s; }
    /* o mesmo desenho de window.MkEstrelas (snippets/mk-aval-estrelas) */
    function est(n) {
      if (window.MkEstrelas) return window.MkEstrelas(n);
      var p = Math.max(0, Math.min(100, n / 5 * 100));
      return '<span class="mav-est" role="img" aria-label="' + num(n) + ' de 5 estrelas"><span class="mav-est__v">' + svg5() +
        '</span><span class="mav-est__c" style="width:' + p + '%">' + svg5() + '</span></span>';
    }
    function quando(iso) {
      var d = new Date(iso), dias = Math.floor((Date.now() - d.getTime()) / 864e5);
      if (dias < 1) return 'hoje';
      if (dias < 2) return 'ontem';
      if (dias < 7) return 'há ' + dias + ' dias';
      if (dias < 31) { var s = Math.floor(dias / 7); return 'há ' + s + (s > 1 ? ' semanas' : ' semana'); }
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }
    var guarda = {
      ler: function (k, pad) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : pad; } catch (e) { return pad; } },
      por: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    };

    /* ============ trava de rolagem (Horizon rola no .page-wrapper ≥990) ============ */
    function travar() {
      var pw = document.querySelector('.page-wrapper');
      if (pw && pw.scrollHeight > pw.clientHeight + 4 && getComputedStyle(pw).overflowY !== 'visible') {
        var antes = pw.style.overflow;
        pw.style.overflow = 'hidden';
        return function () { pw.style.overflow = antes; };
      }
      /* celular: prende o body no lugar em vez de overflow:hidden (armadilha 51) */
      var y = window.scrollY || document.documentElement.scrollTop, b = document.body.style;
      var guardado = [b.position, b.top, b.left, b.right, b.width];
      b.position = 'fixed'; b.top = -y + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      return function () {
        b.position = guardado[0]; b.top = guardado[1]; b.left = guardado[2]; b.right = guardado[3]; b.width = guardado[4];
        window.scrollTo({ top: y, left: 0, behavior: 'instant' });
      };
    }

    /* ================= estado ================= */
    var S = { ordem: 'recentes', nota: null, para: null, midia: false, pagina: 1, itens: [], resumo: null, galeria: [], total: 0, paginas: 1 };
    var carregando = false;

    function urlLista() {
      var q = ['produto=' + encodeURIComponent(PRODUTO), 'ordem=' + S.ordem, 'pagina=' + S.pagina];
      if (S.nota) q.push('nota=' + S.nota);
      if (S.para) q.push('para=' + S.para);
      if (S.midia) q.push('filtro=com-midia');
      if (S.pagina > 1) q.push('galeria=0');
      if (TESTE) q.push('teste=1');
      return API + '/v1/avaliacoes?' + q.join('&');
    }

    function carregar(mais) {
      if (carregando) return;
      carregando = true;
      if (!mais) { S.pagina = 1; }
      var botao = corpo.querySelector('[data-mav-mais]');
      if (botao) { botao.disabled = true; botao.textContent = 'Carregando…'; }
      fetch(urlLista(), { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          carregando = false;
          corpo.setAttribute('aria-busy', 'false');
          S.resumo = d.resumo; /* o resumo da API é sempre do conjunto inteiro, sem filtro */
          if (d.galeria) S.galeria = d.galeria;
          S.total = d.total_filtrado;
          S.paginas = d.paginas;
          S.itens = mais ? S.itens.concat(d.avaliacoes) : d.avaliacoes;
          if (mais) acrescentar(d.avaliacoes); else desenhar();
          if (!mais) extras();
        })
        .catch(function () {
          carregando = false;
          corpo.setAttribute('aria-busy', 'false');
          corpo.innerHTML = '<div class="mav-vazio"><h3>Não carregou agora</h3><p>Não conseguimos buscar as avaliações neste momento.</p>' +
            '<button class="mav-btn" type="button" data-mav-recarrega>Tentar de novo</button></div>';
        });
    }

    /* ================= desenho ================= */
    function htmlVazio() {
      return '<div class="mav-vazio">' +
        (DADOS.nina ? '<img class="mav-vazio__nina" src="' + esc(DADOS.nina) + '" alt="" width="96" height="96" loading="lazy">'
          : '<div class="mav-vazio__selo" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="' + CAM + '"/></svg></div>') +
        '<h3>' + esc(DADOS.vazio_t || 'Seja a primeira pessoa a avaliar') + '</h3>' +
        '<p>' + esc(DADOS.vazio || '') + '</p>' +
        '<button class="mav-btn mav-btn--cheio" type="button" data-mav-abre>' + esc(DADOS.escrever || 'Escrever uma avaliação') + '</button>' +
        '<small>Dá para mandar a foto do corte junto.</small></div>';
    }

    function htmlResumo(r) {
      var maior = Math.max(1, r.dist[1], r.dist[2], r.dist[3], r.dist[4], r.dist[5]);
      var bons = r.dist[4] + r.dist[5];
      var barras = '';
      for (var n = 5; n >= 1; n--) {
        var c = r.dist[n] || 0;
        barras += '<button class="mav-barra" type="button" data-mav-nota="' + n + '" aria-pressed="' + (S.nota === n) + '"' + (c ? '' : ' disabled') +
          ' aria-label="' + plural(c, 'avaliação', 'avaliações') + ' com ' + n + (n > 1 ? ' estrelas' : ' estrela') + '">' +
          '<span>' + n + '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg></span>' +
          '<span class="mav-barra__t"><i data-w="' + Math.round(c / maior * 100) + '"></i></span>' +
          '<span class="mav-barra__n">' + c + '</span></button>';
      }
      return '<div class="mav-res">' +
        '<div class="mav-res__topo"><b class="mav-res__media">' + num(r.media.toFixed(1)) + '</b>' +
        '<div>' + est(r.media) + '<span class="mav-res__total">' + plural(r.total, 'avaliação', 'avaliações') + '</span></div></div>' +
        '<p class="mav-res__rec"><b>' + Math.round(bons / r.total * 100) + '%</b> deram 4 ou 5 estrelas</p>' +
        '<div class="mav-barras">' + barras + '</div>' +
        '<button class="mav-btn mav-btn--cheio" type="button" data-mav-abre>' + esc(DADOS.escrever || 'Escrever uma avaliação') + '</button>' +
        '</div>';
    }

    function htmlMini(m, i, origem) {
      var img = m.tipo === 'video' ? (m.capa ? '<img src="' + esc(m.capa) + '" alt="" loading="lazy" decoding="async">' : '<span class="mav-mini__vid"></span>')
        : '<img src="' + esc(m.url) + '" alt="" loading="lazy" decoding="async">';
      var play = m.tipo === 'video' ? '<span class="mav-mini__play"><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>' + (m.d ? Math.round(m.d) + ' s' : 'vídeo') + '</span>' : '';
      return '<button class="mav-mini" type="button" data-mav-ver="' + origem + '" data-mav-i="' + i + '" aria-label="Abrir ' + (m.tipo === 'video' ? 'vídeo' : 'foto') + ' da avaliação">' + img + play + '</button>';
    }

    function htmlGaleria() {
      if (!S.galeria || !S.galeria.length) return '';
      return '<div class="mav-gal"><div class="mav-gal__topo"><h3>' + esc(DADOS.galeria || 'Fotos e vídeos de clientes') + ' <small style="font-weight:400;color:#8a7365">(' + S.galeria.length + ')</small></h3>' +
        '<div class="mav-gal__setas"><button class="mav-seta" type="button" data-mav-gal="-1" aria-label="Voltar"><svg viewBox="0 0 24 24"><path d="m14.5 5-6 7 6 7"/></svg></button>' +
        '<button class="mav-seta" type="button" data-mav-gal="1" aria-label="Avançar"><svg viewBox="0 0 24 24"><path d="m9.5 5 6 7-6 7"/></svg></button></div></div>' +
        '<div class="mav-gal__trilho" data-mav-trilho>' + S.galeria.map(function (m, i) { return htmlMini(m, i, 'gal'); }).join('') + '</div></div>';
    }

    function htmlFerramentas() {
      var r = S.resumo, chips = '';
      if (S.nota) chips += '<button class="mav-chip" type="button" aria-pressed="true" data-mav-tira-nota>' + S.nota + ' <svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + CAM + '"/></svg> ✕</button>';
      if (r.com_midia) chips += '<button class="mav-chip" type="button" data-mav-midia aria-pressed="' + S.midia + '">Com foto ou vídeo <small>' + r.com_midia + '</small></button>';
      Object.keys(PARA).forEach(function (k) {
        if (r.para && r.para[k]) chips += '<button class="mav-chip" type="button" data-mav-para="' + k + '" aria-pressed="' + (S.para === k) + '">' + PARA[k] + ' <small>' + r.para[k] + '</small></button>';
      });
      var ordem = '<label class="mav-ordem"><span>Ordenar</span><select data-mav-ordem>' +
        ORDENS.map(function (o) { return '<option value="' + o[0] + '"' + (S.ordem === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label>';
      return '<div class="mav-ferr"><div class="mav-chips" role="group" aria-label="Filtrar avaliações">' + chips + '</div>' + ordem + '</div>';
    }

    function htmlCartao(a, k) {
      var longo = a.texto.length > 420;
      var midias = a.midias.length ? '<div class="mav-c__midias">' + a.midias.map(function (m, i) { return htmlMini(m, i, 'c:' + a.id); }).join('') + '</div>' : '';
      var local = [a.cidade].filter(Boolean).join('');
      var votos = guarda.ler('mav-votos', []);
      var votou = votos.indexOf(a.id) >= 0;
      var marcas = (a.teste ? '<span class="mav-marca mav-marca--teste">Teste</span>' : '') +
        (a.destaque ? '<span class="mav-marca mav-marca--dest">Em destaque</span>' : '');
      var origem = a.origem ? '<span class="mav-origem">' + esc(a.origem) + '</span>' : '';
      return '<article class="mav-c" id="mav-' + a.id + '" style="--mav-d:' + (reduz ? 0 : Math.min(k, 6) * 60) + 'ms">' +
        '<div class="mav-c__topo"><div class="mav-c__marcas">' + est(a.nota) + marcas + '</div><time datetime="' + esc(a.data) + '">' + quando(a.data) + '</time></div>' +
        (a.titulo ? '<h3 class="mav-c__tit">' + esc(a.titulo) + '</h3>' : '') +
        '<p class="mav-c__txt' + (longo ? ' mav-c__txt--corta' : '') + '">' + esc(a.texto) + '</p>' +
        (longo ? '<button class="mav-c__mais" type="button" data-mav-lermais aria-expanded="false">Ler mais</button>' : '') +
        midias +
        '<div class="mav-c__pe"><div class="mav-quem"><span class="mav-av" aria-hidden="true">' + esc(a.nome.charAt(0).toUpperCase()) + '</span>' +
        '<span><b>' + esc(a.nome) + '</b>' + (local ? '<small>' + esc(local) + '</small>' : '') + '</span></div>' +
        (a.verificada ? '<span class="mav-selo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>Compra verificada</span>' : '') +
        origem +
        (a.para.length ? '<span class="mav-c__para">' + a.para.map(function (p) { return '<span class="mav-tag">' + esc(PARA[p] || p) + '</span>'; }).join('') + '</span>' : '') +
        '</div>' +
        (a.resposta ? '<div class="mav-c__resp"><b>Resposta da Maskavo</b><p>' + esc(a.resposta.texto) + '</p></div>' : '') +
        '<div class="mav-c__util"><span>Foi útil?</span><button class="mav-util" type="button" data-mav-util="' + a.id + '" aria-pressed="' + votou + '"' + (votou ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10.6v9H4.4v-9Zm3 9V10.6l3.4-6.8c1.5 0 2.4 1 2.2 2.4l-.5 3h4.1c1.2 0 2 1 1.7 2.2l-1.5 6c-.2 1-1 1.6-2 1.6Z"/></svg>' +
        '<span>' + (a.util || 0) + '</span><span class="mav-oculto"> pessoas acharam útil</span></button></div>' +
        '</article>';
    }

    function htmlMais() {
      return S.pagina < S.paginas ? '<button class="mav-btn mav-maisb" type="button" data-mav-mais>Ver mais avaliações</button>' : '';
    }

    function desenhar() {
      var r = S.resumo;
      var n = raiz.querySelector('[data-mav-aba-n]');
      if (n) n.textContent = r && r.total ? '(' + r.total + ')' : '';
      if (!r || !r.total) { corpo.innerHTML = htmlVazio(); return; }
      var lista = S.itens.length ? S.itens.map(htmlCartao).join('')
        : '<div class="mav-filtro-vazio">Nenhuma avaliação com esse filtro. <button class="mav-c__mais" type="button" data-mav-limpa>Limpar filtros</button></div>';
      var filtrando = S.nota || S.para || S.midia;
      corpo.innerHTML = '<div class="mav-grade">' + htmlResumo(r) +
        '<div class="mav-lado">' + htmlGaleria() + htmlFerramentas() +
        '<p class="mav-conta" aria-live="polite">' + (filtrando ? plural(S.total, 'avaliação encontrada', 'avaliações encontradas') : 'Mostrando ' + Math.min(S.itens.length, S.total) + ' de ' + plural(S.total, 'avaliação', 'avaliações')) + '</p>' +
        '<div class="mav-lista" data-mav-lista>' + lista + '</div>' + htmlMais() + '</div></div>';
      /* as barras crescem depois de desenhadas */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          corpo.querySelectorAll('.mav-barra__t i').forEach(function (i) { i.style.width = i.getAttribute('data-w') + '%'; });
        });
      });
      setasGaleria();
    }

    function acrescentar(novos) {
      var lista = corpo.querySelector('[data-mav-lista]');
      var base = S.itens.length - novos.length;
      lista.insertAdjacentHTML('beforeend', novos.map(function (a, k) { return htmlCartao(a, k); }).join(''));
      var velho = corpo.querySelector('[data-mav-mais]');
      if (velho) velho.remove();
      lista.insertAdjacentHTML('afterend', htmlMais());
      var conta = corpo.querySelector('.mav-conta');
      if (conta && !(S.nota || S.para || S.midia)) conta.textContent = 'Mostrando ' + S.itens.length + ' de ' + plural(S.total, 'avaliação', 'avaliações');
      var primeiro = lista.children[base];
      if (primeiro && primeiro.focus) { primeiro.setAttribute('tabindex', '-1'); primeiro.focus({ preventScroll: true }); }
    }

    function setasGaleria() {
      var t = corpo.querySelector('[data-mav-trilho]');
      if (!t) return;
      var bs = corpo.querySelectorAll('[data-mav-gal]');
      var atualiza = function () {
        var sobra = t.scrollWidth - t.clientWidth;
        bs[0].disabled = t.scrollLeft < 4;
        bs[1].disabled = t.scrollLeft > sobra - 4;
        corpo.querySelector('.mav-gal__setas').hidden = sobra < 4;
      };
      t.addEventListener('scroll', atualiza, { passive: true });
      atualiza();
    }

    /* ================= estrelas no topo da PDP + JSON-LD ================= */
    function extras() {
      var r = S.resumo;
      var topo = document.querySelector('[data-mav-topo]');
      /* estrelas ao lado do nome do cookie: aparecem a partir da 1ª avaliação aprovada */
      if (topo && r && r.total >= 1) {
        topo.innerHTML = est(r.media) + '<span>' + num(r.media.toFixed(1)) + ' · ' + plural(r.total, 'avaliação', 'avaliações') + '</span>';
        topo.setAttribute('aria-label', num(r.media.toFixed(1)) + ' de 5 estrelas, ' + plural(r.total, 'avaliação', 'avaliações'));
        topo.hidden = false;
      }
      /* SEO: só com avaliação real e nunca no modo de teste */
      if (TESTE || !r || !r.total || !DADOS.produto || document.querySelector('script[data-mav-ld]')) return;
      var reais = S.itens.filter(function (a) { return !a.teste; });
      if (!reais.length) return;
      var p = DADOS.produto;
      var ld = {
        '@context': 'https://schema.org', '@type': 'Product', '@id': p.url + '#produto', name: p.name, url: p.url,
        brand: { '@type': 'Brand', name: 'Maskavo Factory' },
        aggregateRating: { '@type': 'AggregateRating', ratingValue: r.media, reviewCount: r.total, bestRating: 5, worstRating: 1 },
        review: reais.slice(0, 10).map(function (a) {
          var rv = { '@type': 'Review', author: { '@type': 'Person', name: a.nome }, datePublished: a.data.slice(0, 10),
            reviewRating: { '@type': 'Rating', ratingValue: a.nota, bestRating: 5, worstRating: 1 }, reviewBody: a.texto };
          if (a.titulo) rv.name = a.titulo;
          return rv;
        })
      };
      if (p.image) ld.image = [p.image];
      if (p.description) ld.description = p.description;
      if (p.sku) ld.sku = p.sku;
      if (p.price != null) ld.offers = { '@type': 'Offer', price: Number(p.price).toFixed(2), priceCurrency: 'BRL', url: p.url,
        availability: p.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock' };
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-mav-ld', '');
      s.textContent = JSON.stringify(ld);
      document.head.appendChild(s);
    }

    /* ================= cliques na área das avaliações ================= */
    corpo.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-mav-abre]'))) { abrirForm(b); return; }
      if (t.closest('[data-mav-recarrega]')) { corpo.innerHTML = ''; carregar(false); return; }
      if ((b = t.closest('[data-mav-nota]'))) {
        var n = Number(b.getAttribute('data-mav-nota'));
        S.nota = S.nota === n ? null : n; carregar(false); return;
      }
      if (t.closest('[data-mav-tira-nota]')) { S.nota = null; carregar(false); return; }
      if (t.closest('[data-mav-midia]')) { S.midia = !S.midia; carregar(false); return; }
      if ((b = t.closest('[data-mav-para]'))) { var k = b.getAttribute('data-mav-para'); S.para = S.para === k ? null : k; carregar(false); return; }
      if (t.closest('[data-mav-limpa]')) { S.nota = S.para = null; S.midia = false; carregar(false); return; }
      if (t.closest('[data-mav-mais]')) { S.pagina++; carregar(true); return; }
      if ((b = t.closest('[data-mav-lermais]'))) {
        var p = b.previousElementSibling, aberto = b.getAttribute('aria-expanded') === 'true';
        p.classList.toggle('mav-c__txt--corta', aberto);
        b.setAttribute('aria-expanded', aberto ? 'false' : 'true');
        b.textContent = aberto ? 'Ler mais' : 'Ler menos';
        return;
      }
      if ((b = t.closest('[data-mav-gal]'))) {
        var tr = corpo.querySelector('[data-mav-trilho]');
        tr.scrollBy({ left: Number(b.getAttribute('data-mav-gal')) * tr.clientWidth * 0.8, behavior: reduz ? 'auto' : 'smooth' });
        return;
      }
      if ((b = t.closest('[data-mav-ver]'))) { abrirVisor(b.getAttribute('data-mav-ver'), Number(b.getAttribute('data-mav-i')), b); return; }
      if ((b = t.closest('[data-mav-util]'))) { votar(b); }
    });
    corpo.addEventListener('change', function (e) {
      if (e.target.matches('[data-mav-ordem]')) { S.ordem = e.target.value; carregar(false); }
    });

    /* estrelas do topo levam à aba de avaliações */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#mk-avaliacoes"]');
      if (a) abrirAba('avaliacoes');
    });

    /* ================= voto "foi útil" ================= */
    function quemSou() {
      var q = guarda.ler('mav-quem', null);
      if (!q) {
        var b = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(b);
        q = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
        guarda.por('mav-quem', q);
      }
      return q;
    }
    function votar(b) {
      var id = b.getAttribute('data-mav-util');
      var n = b.querySelector('span');
      b.disabled = true;
      b.setAttribute('aria-pressed', 'true');
      n.textContent = Number(n.textContent) + 1;
      b.classList.add('mav-pula');
      var votos = guarda.ler('mav-votos', []);
      votos.push(id); guarda.por('mav-votos', votos.slice(-300));
      fetch(API + '/v1/util', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quem: quemSou() }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok) n.textContent = d.util; })
        .catch(function () {});
    }

    /* ================= visualizador ================= */
    var V = raiz.querySelector('[data-mav-v]');
    var trilho = V.querySelector('[data-mav-v-trilho]');
    var vAtual = 0, vItens = [], vDestrava = null, vFoco = null;
    document.body.appendChild(V); /* fora da seção: nenhum ancestral com transform */

    function itensDe(origem) {
      if (origem === 'gal') return S.galeria;
      var id = origem.slice(2);
      var a = S.itens.filter(function (x) { return x.id === id; })[0];
      if (!a) return [];
      return a.midias.map(function (m) { return Object.assign({}, m, { avaliacao: a }); });
    }
    function abrirVisor(origem, i, botao) {
      vItens = itensDe(origem);
      if (!vItens.length) return;
      vFoco = botao;
      trilho.innerHTML = vItens.map(function (m, k) { return '<div class="mav-v__slide" data-k="' + k + '"></div>'; }).join('');
      V.hidden = false;
      vDestrava = travar();
      requestAnimationFrame(function () { V.classList.add('mav-vis'); });
      irPara(i, true);
      V.querySelector('[data-mav-v-fecha]').focus();
      document.addEventListener('keydown', teclaVisor);
    }
    function montarSlide(k) {
      var el = trilho.children[k];
      if (!el || el.firstChild) return;
      var m = vItens[k];
      el.innerHTML = m.tipo === 'video'
        ? '<video src="' + esc(m.url) + '" controls playsinline preload="metadata"' + (m.capa ? ' poster="' + esc(m.capa) + '"' : '') + '></video>'
        : '<img src="' + esc(m.url) + '" alt="Foto enviada por quem avaliou" draggable="false">';
    }
    function irPara(i, sem) {
      vAtual = Math.max(0, Math.min(vItens.length - 1, i));
      [vAtual - 1, vAtual, vAtual + 1].forEach(montarSlide);
      trilho.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
      if (sem) trilho.classList.add('mav-arrasta');
      trilho.style.transform = 'translateX(' + (-vAtual * 100) + '%)';
      if (sem) { trilho.offsetWidth; trilho.classList.remove('mav-arrasta'); }
      V.querySelector('[data-mav-v-conta]').textContent = (vAtual + 1) + ' / ' + vItens.length;
      V.querySelector('[data-mav-v-ir="-1"]').disabled = vAtual === 0;
      V.querySelector('[data-mav-v-ir="1"]').disabled = vAtual === vItens.length - 1;
      var a = vItens[vAtual].avaliacao || {};
      V.querySelector('[data-mav-v-leg]').innerHTML = est(a.nota || 0) +
        '<b>' + esc(a.nome || '') + (a.cidade ? ' <span>· ' + esc(a.cidade) + '</span>' : '') + (a.teste ? ' <span>· TESTE</span>' : '') + '</b>' +
        (a.titulo || a.texto ? '<p>' + esc(a.titulo ? a.titulo + '. ' : '') + esc(a.texto || '') + '</p>' : '') +
        '<button type="button" data-mav-v-avaliacao="' + esc(a.id || '') + '">Ver avaliação</button>';
    }
    function fecharVisor() {
      V.classList.remove('mav-vis');
      document.removeEventListener('keydown', teclaVisor);
      trilho.querySelectorAll('video').forEach(function (v) { v.pause(); });
      if (vDestrava) { vDestrava(); vDestrava = null; }
      setTimeout(function () { V.hidden = true; trilho.innerHTML = ''; }, reduz ? 0 : 260);
      if (vFoco && vFoco.focus) vFoco.focus({ preventScroll: true });
    }
    function teclaVisor(e) {
      if (e.key === 'Escape') fecharVisor();
      else if (e.key === 'ArrowRight') irPara(vAtual + 1);
      else if (e.key === 'ArrowLeft') irPara(vAtual - 1);
    }
    V.addEventListener('click', function (e) {
      var b;
      if (e.target.closest('[data-mav-v-fecha]')) { fecharVisor(); return; }
      if ((b = e.target.closest('[data-mav-v-ir]'))) { irPara(vAtual + Number(b.getAttribute('data-mav-v-ir'))); return; }
      if ((b = e.target.closest('[data-mav-v-avaliacao]'))) {
        var id = b.getAttribute('data-mav-v-avaliacao');
        fecharVisor();
        var alvo = document.getElementById('mav-' + id);
        if (!alvo) { /* a avaliação ainda não está na lista: tira os filtros e procura de novo */ return; }
        alvo.classList.add('mav-c--alvo');
        setTimeout(function () { alvo.scrollIntoView({ behavior: reduz ? 'auto' : 'smooth', block: 'start' }); }, 60);
        setTimeout(function () { alvo.classList.remove('mav-c--alvo'); }, 2400);
        return;
      }
      if (e.target.classList.contains('mav-v__slide')) fecharVisor();
    });
    /* arrastar com o dedo (ou o mouse) */
    (function () {
      var x0 = null, y0 = 0, dx = 0, larg = 1, horizontal = null;
      var palco = V.querySelector('[data-mav-v-palco]');
      palco.addEventListener('pointerdown', function (e) {
        if (e.target.closest('video') && e.pointerType === 'mouse') return;
        x0 = e.clientX; y0 = e.clientY; dx = 0; horizontal = null; larg = palco.clientWidth || 1;
      });
      palco.addEventListener('pointermove', function (e) {
        if (x0 === null) return;
        dx = e.clientX - x0;
        if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(e.clientY - y0) > 8)) horizontal = Math.abs(dx) > Math.abs(e.clientY - y0);
        if (!horizontal) return;
        var borda = (vAtual === 0 && dx > 0) || (vAtual === vItens.length - 1 && dx < 0) ? 0.3 : 1;
        trilho.classList.add('mav-arrasta');
        trilho.style.transform = 'translateX(calc(' + (-vAtual * 100) + '% + ' + dx * borda + 'px))';
      });
      function solta() {
        if (x0 === null) return;
        trilho.classList.remove('mav-arrasta');
        if (horizontal && Math.abs(dx) > Math.min(90, larg * 0.18)) irPara(vAtual + (dx < 0 ? 1 : -1));
        else if (horizontal) irPara(vAtual);
        x0 = null;
      }
      palco.addEventListener('pointerup', solta);
      palco.addEventListener('pointercancel', solta);
      palco.addEventListener('pointerleave', solta);
    })();

    /* ================= formulário ================= */
    var F = raiz.querySelector('[data-mav-f]');
    var forma = F.querySelector('[data-mav-forma]');
    var obrigado = F.querySelector('[data-mav-obrigado]');
    var erroEl = F.querySelector('[data-mav-erro]');
    var previas = F.querySelector('[data-mav-previas]');
    var entrada = F.querySelector('[data-mav-arquivos]');
    var solta = F.querySelector('[data-mav-solta]');
    var prog = F.querySelector('[data-mav-prog]');
    var enviarB = F.querySelector('[data-mav-enviar]');
    var fDestrava = null, fFoco = null, enviando = false;
    var arquivos = []; /* {id, tipo, blob, previa, l, a, d, capa, pronto, erro, el} */
    var robo = { id: null, pedido: null };
    document.body.appendChild(F);

    function abrirForm(botao) {
      fFoco = botao || document.activeElement;
      F.hidden = false;
      fDestrava = travar();
      requestAnimationFrame(function () { F.classList.add('mav-vis'); });
      document.addEventListener('keydown', teclaForm);
      prepararRobo();
      setTimeout(function () { var s = F.querySelector('.mav-f__x'); if (s) s.focus({ preventScroll: true }); }, 60);
    }
    function fecharForm() {
      if (enviando) return;
      F.classList.remove('mav-vis');
      document.removeEventListener('keydown', teclaForm);
      if (fDestrava) { fDestrava(); fDestrava = null; }
      setTimeout(function () {
        F.hidden = true;
        if (!obrigado.hidden) { /* depois do obrigado, o formulário volta limpo */
          forma.reset(); limparArquivos(); pintaEstrelas(0); obrigado.hidden = true; forma.hidden = false;
          if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
        }
      }, reduz ? 0 : 300);
      if (fFoco && fFoco.focus) fFoco.focus({ preventScroll: true });
    }
    function teclaForm(e) {
      if (e.key === 'Escape') { fecharForm(); return; }
      if (e.key !== 'Tab') return;
      /* o foco fica preso no painel */
      var foc = F.querySelectorAll('button:not([disabled]), input:not([disabled]), textarea, select, a[href], iframe');
      foc = Array.prototype.filter.call(foc, function (x) { return x.offsetParent !== null; });
      if (!foc.length) return;
      var ini = foc[0], fim = foc[foc.length - 1];
      if (e.shiftKey && document.activeElement === ini) { e.preventDefault(); fim.focus(); }
      else if (!e.shiftKey && document.activeElement === fim) { e.preventDefault(); ini.focus(); }
    }
    F.addEventListener('click', function (e) { if (e.target.closest('[data-mav-fecha]')) fecharForm(); });

    /* ---- Turnstile (anti-robô do Cloudflare), carregado só quando o painel abre ---- */
    function prepararRobo() {
      if (!SITEKEY || robo.id !== null || robo.pedido) return;
      robo.pedido = new Promise(function (ok, falha) {
        if (window.turnstile) return ok();
        window.mavTurnstile = ok;
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=mavTurnstile';
        s.async = true; s.defer = true; s.onerror = falha;
        document.head.appendChild(s);
      }).then(function () {
        robo.id = turnstile.render(F.querySelector('[data-mav-robo]'), {
          sitekey: SITEKEY, language: 'pt-br', theme: 'light', size: 'flexible', appearance: 'interaction-only',
          'response-field': false
        });
      }).catch(function () { robo.pedido = null; });
    }
    function tokenRobo() {
      return new Promise(function (ok) {
        if (!window.turnstile || robo.id === null) return ok('');
        var t = turnstile.getResponse(robo.id);
        if (t) return ok(t);
        /* ainda resolvendo: espera até 12 s */
        var n = 0, iv = setInterval(function () {
          t = turnstile.getResponse(robo.id);
          if (t || ++n > 48) { clearInterval(iv); ok(t || ''); }
        }, 250);
      });
    }

    /* ---- estrelas grandes ---- */
    var ROT = ['', 'Não gostei', 'Poderia ser melhor', 'Ok', 'Gostei', 'Amei!'];
    var labels = F.querySelectorAll('.mav-f__estrelas label');
    var rotNota = F.querySelector('[data-mav-nota-rot]');
    function notaAtual() { var c = forma.querySelector('input[name="nota"]:checked'); return c ? Number(c.value) : 0; }
    function pintaEstrelas(n, provisorio) {
      labels.forEach(function (l, i) { l.classList.toggle('mav-acesa', i < n); });
      rotNota.textContent = n ? ROT[n] : 'Toque nas estrelas';
      if (!provisorio) F.querySelector('.mav-f__notas').classList.remove('mav-ruim');
    }
    forma.querySelectorAll('input[name="nota"]').forEach(function (r) {
      r.addEventListener('change', function () { pintaEstrelas(notaAtual()); });
    });
    labels.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) pintaEstrelas(i + 1, true); });
      l.addEventListener('mouseleave', function () { pintaEstrelas(notaAtual(), true); });
    });

    var texto = forma.querySelector('textarea[name="texto"]');
    var conta = F.querySelector('[data-mav-conta]');
    texto.addEventListener('input', function () { conta.textContent = texto.value.length + '/2000'; });
    forma.addEventListener('input', function (e) {
      var c = e.target.closest('.mav-f__campo, .mav-f__ok');
      if (c) c.classList.remove('mav-ruim');
    });

    /* ---- fotos e vídeo: comprimidos NO NAVEGADOR antes de subir ---- */
    var MAX_FOTOS = 5, MAX_VIDEO_MB = 25, MAX_VIDEO_S = 30, LADO = 1600;
    function blobDeCanvas(c, q) { return new Promise(function (ok) { c.toBlob(function (b) { ok(b); }, 'image/jpeg', q); }); }
    function carregarImagem(arq) {
      if (window.createImageBitmap) {
        return createImageBitmap(arq, { imageOrientation: 'from-image' }).catch(function () { return carregarImg(arq); });
      }
      return carregarImg(arq);
    }
    function carregarImg(arq) {
      return new Promise(function (ok, falha) {
        var u = URL.createObjectURL(arq), im = new Image();
        im.onload = function () { ok(im); };
        im.onerror = function () { URL.revokeObjectURL(u); falha(new Error('imagem')); };
        im.src = u;
      });
    }
    function comprimirFoto(arq) {
      return carregarImagem(arq).then(function (im) {
        var w = im.width || im.naturalWidth, h = im.height || im.naturalHeight;
        var k = Math.min(1, LADO / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        var g = c.getContext('2d');
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
        g.drawImage(im, 0, 0, c.width, c.height);
        if (im.close) im.close();
        return blobDeCanvas(c, 0.82).then(function (b) { return { blob: b, l: c.width, a: c.height }; });
      });
    }
    function lerVideo(arq) {
      return new Promise(function (ok, falha) {
        var v = document.createElement('video'), u = URL.createObjectURL(arq), feito = false;
        v.muted = true; v.playsInline = true; v.preload = 'metadata'; v.src = u;
        var fim = function (res) { if (feito) return; feito = true; ok(res); };
        v.onerror = function () { falha(new Error('Esse vídeo não abriu aqui. Tente MP4 ou MOV.')); };
        v.onloadedmetadata = function () {
          var d = v.duration, info = { d: isFinite(d) ? d : 0, l: v.videoWidth, a: v.videoHeight, previa: u, capa: null };
          if (info.d > MAX_VIDEO_S + 1) { falha(new Error('O vídeo tem ' + Math.round(info.d) + ' s. O máximo é ' + MAX_VIDEO_S + ' s.')); return; }
          v.onseeked = function () {
            try {
              var k = Math.min(1, 960 / Math.max(v.videoWidth, v.videoHeight));
              var c = document.createElement('canvas');
              c.width = Math.round(v.videoWidth * k); c.height = Math.round(v.videoHeight * k);
              c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
              blobDeCanvas(c, 0.8).then(function (b) { info.capa = b; fim(info); });
            } catch (e) { fim(info); }
          };
          try { v.currentTime = Math.min(1, (info.d || 2) / 2); } catch (e) { fim(info); }
          setTimeout(function () { fim(info); }, 4000);
        };
      });
    }

    function desenhaPrevia(item) {
      var li = document.createElement('li');
      li.className = 'mav-pv mav-pv--carrega';
      li.innerHTML = '<button class="mav-pv__x" type="button" aria-label="Tirar este arquivo"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (item.tipo === 'video' ? '<span class="mav-pv__tag">vídeo</span>' : '') +
        '<span class="mav-pv__barra" hidden><i></i></span>';
      li.querySelector('.mav-pv__x').addEventListener('click', function () {
        if (enviando) return;
        arquivos = arquivos.filter(function (x) { return x !== item; });
        li.remove();
        if (item.previaUrl) URL.revokeObjectURL(item.previaUrl);
      });
      item.el = li;
      previas.appendChild(li);
    }
    function mostraPrevia(item, url) {
      item.el.classList.remove('mav-pv--carrega');
      var img = document.createElement('img');
      img.alt = ''; img.src = url;
      item.el.insertBefore(img, item.el.firstChild);
    }
    function avisoArquivo(msg) {
      var p = F.querySelector('.mav-f__msg');
      if (!p) { p = document.createElement('p'); p.className = 'mav-f__msg'; previas.after(p); }
      p.textContent = msg;
      clearTimeout(avisoArquivo.t);
      avisoArquivo.t = setTimeout(function () { p.remove(); }, 6000);
    }
    function adicionar(lista) {
      Array.prototype.forEach.call(lista, function (arq) {
        var fotos = arquivos.filter(function (x) { return x.tipo === 'foto'; }).length;
        var videos = arquivos.filter(function (x) { return x.tipo === 'video'; }).length;
        if (/^video\//.test(arq.type) || /\.(mov|mp4|m4v|webm)$/i.test(arq.name)) {
          if (videos >= 1) return avisoArquivo('Só dá para mandar 1 vídeo.');
          if (arq.size > MAX_VIDEO_MB * 1048576) return avisoArquivo('O vídeo tem ' + Math.round(arq.size / 1048576) + ' MB. O máximo é ' + MAX_VIDEO_MB + ' MB. Tente um trecho menor.');
          var it = { tipo: 'video', blob: arq, pronto: false };
          arquivos.push(it); desenhaPrevia(it);
          lerVideo(arq).then(function (info) {
            it.d = info.d; it.l = info.l; it.a = info.a; it.capa = info.capa; it.previaUrl = info.previa; it.pronto = true;
            if (info.capa) mostraPrevia(it, URL.createObjectURL(info.capa));
            else { it.el.classList.remove('mav-pv--carrega'); it.el.insertAdjacentHTML('afterbegin', '<video src="' + info.previa + '#t=0.5" muted playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover"></video>'); }
          }).catch(function (e) {
            arquivos = arquivos.filter(function (x) { return x !== it; }); it.el.remove(); avisoArquivo(e.message);
          });
        } else if (/^image\//.test(arq.type) || /\.(jpe?g|png|webp|heic|heif|gif)$/i.test(arq.name)) {
          if (fotos >= MAX_FOTOS) return avisoArquivo('No máximo ' + MAX_FOTOS + ' fotos.');
          var f = { tipo: 'foto', pronto: false };
          arquivos.push(f); desenhaPrevia(f);
          comprimirFoto(arq).then(function (r) {
            f.blob = r.blob; f.l = r.l; f.a = r.a; f.pronto = true;
            f.previaUrl = URL.createObjectURL(r.blob);
            mostraPrevia(f, f.previaUrl);
          }).catch(function () {
            arquivos = arquivos.filter(function (x) { return x !== f; }); f.el.remove();
            avisoArquivo('Não conseguimos abrir “' + arq.name + '”. Envie em JPG ou PNG.');
          });
        } else {
          avisoArquivo('“' + arq.name + '” não é foto nem vídeo.');
        }
      });
    }
    function limparArquivos() {
      arquivos.forEach(function (x) { if (x.previaUrl) URL.revokeObjectURL(x.previaUrl); });
      arquivos = []; previas.innerHTML = '';
    }
    entrada.addEventListener('change', function () { adicionar(entrada.files); entrada.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.add('mav-sobre'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      solta.addEventListener(ev, function (e) { e.preventDefault(); solta.classList.remove('mav-sobre'); });
    });
    solta.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) adicionar(e.dataTransfer.files); });

    /* ---- validação ---- */
    function marca(el) { var c = el.closest('.mav-f__campo, .mav-f__ok, .mav-f__notas'); if (c) c.classList.add('mav-ruim'); }
    function erro(msg, el) {
      erroEl.textContent = msg; erroEl.hidden = false;
      if (el) { marca(el); el.focus({ preventScroll: true }); (el.closest('.mav-f__campo, .mav-f__ok, .mav-f__notas') || el).scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' }); }
    }
    function validar() {
      erroEl.hidden = true;
      var el = forma.elements;
      if (!notaAtual()) { F.querySelector('.mav-f__notas').classList.add('mav-ruim'); erro('Escolha de 1 a 5 estrelas.', forma.querySelector('input[name="nota"]')); return false; }
      if (el.texto.value.trim().length < 10) { erro('Conte um pouco mais na sua avaliação (mínimo de 10 letras).', el.texto); return false; }
      if (el.nome.value.trim().length < 2) { erro('Diga seu nome.', el.nome); return false; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.email.value.trim())) { erro('Confira o e-mail.', el.email); return false; }
      if (!el.consentimento.checked) { erro('Para publicar, precisamos do seu de acordo.', el.consentimento); return false; }
      if (arquivos.some(function (x) { return !x.pronto; })) { erro('Espere as fotos terminarem de carregar.'); return false; }
      return true;
    }

    /* ---- envio ---- */
    function postar(caminho, dados) {
      return fetch(API + caminho, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dados) })
        .then(function (r) { return r.json().catch(function () { return { ok: false, erro: 'Resposta inesperada (' + r.status + ').' }; }); });
    }
    function subir(bilhete, item, blob, tipo, extra, aoProgresso) {
      return new Promise(function (ok, falha) {
        var q = 'bilhete=' + bilhete + '&tipo=' + tipo;
        Object.keys(extra).forEach(function (k) { if (extra[k] != null) q += '&' + k + '=' + encodeURIComponent(extra[k]); });
        var x = new XMLHttpRequest();
        x.open('PUT', API + '/v1/midia?' + q);
        x.setRequestHeader('Content-Type', blob.type || 'application/octet-stream');
        x.upload.onprogress = function (e) { if (e.lengthComputable) aoProgresso(e.loaded); };
        x.onload = function () {
          var d = {}; try { d = JSON.parse(x.responseText); } catch (e) {}
          if (x.status === 200 && d.ok) ok(d); else falha(new Error(d.erro || 'falha ao enviar arquivo'));
        };
        x.onerror = function () { falha(new Error('A conexão caiu no meio do envio.')); };
        x.send(blob);
      });
    }
    function estadoEnvio(ligado, texto) {
      enviando = ligado;
      enviarB.disabled = ligado;
      prog.hidden = !ligado;
      if (texto) prog.querySelector('span').textContent = texto;
      forma.querySelectorAll('input, textarea').forEach(function (i) { i.readOnly = ligado; });
    }
    function progresso(p) { prog.querySelector('i').style.width = Math.round(p * 100) + '%'; }

    forma.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando || !validar()) return;
      var el = forma.elements;
      estadoEnvio(true, 'Conferindo…');
      progresso(0.03);
      var paras = Array.prototype.map.call(forma.querySelectorAll('input[name="para"]:checked'), function (c) { return c.value; });
      tokenRobo().then(function (tk) {
        if (!tk && SITEKEY) throw new Error('Confirme que você não é um robô (a caixinha acima do botão) e tente de novo.');
        return postar('/v1/envio', { turnstile: tk, produto: PRODUTO, site: forma.elements.site.value });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        var bilhete = d.bilhete;
        var fila = [];
        arquivos.forEach(function (it) {
          fila.push({ it: it, blob: it.blob, tipo: it.tipo, extra: { l: it.l, a: it.a, d: it.d ? it.d.toFixed(1) : null } });
          if (it.tipo === 'video' && it.capa) fila.push({ it: it, blob: it.capa, tipo: 'capa', extra: { l: it.l, a: it.a } });
        });
        var total = fila.reduce(function (s, f) { return s + f.blob.size; }, 0) || 1, feito = 0, ids = [];
        var seq = Promise.resolve();
        fila.forEach(function (f, k) {
          seq = seq.then(function () {
            estadoEnvio(true, 'Enviando ' + (f.tipo === 'video' ? 'o vídeo' : f.tipo === 'capa' ? 'a capa do vídeo' : 'foto') + '… ');
            var barra = f.it.el.querySelector('.mav-pv__barra');
            if (f.tipo !== 'capa') barra.hidden = false;
            if (f.tipo === 'capa') f.extra.capa_de = f.it.idRemoto;
            return subir(bilhete, f.it, f.blob, f.tipo, f.extra, function (n) {
              if (f.tipo !== 'capa') barra.querySelector('i').style.width = Math.round(n / f.blob.size * 100) + '%';
              progresso(0.05 + 0.85 * (feito + n) / total);
            }).then(function (r) {
              feito += f.blob.size;
              if (f.tipo === 'capa') return;
              f.it.idRemoto = r.id; ids.push(r.id);
              barra.hidden = true; f.it.el.classList.add('mav-pv--ok');
            });
          });
        });
        return seq.then(function () {
          estadoEnvio(true, 'Finalizando…');
          progresso(0.94);
          return postar('/v1/avaliacoes', {
            bilhete: bilhete, produto: PRODUTO, produto_titulo: (DADOS.produto || {}).name, nota: notaAtual(),
            titulo: el.titulo.value, texto: el.texto.value, nome: el.nome.value, email: el.email.value,
            cidade: el.cidade.value, pedido: el.pedido.value, para: paras, midias: ids, consentimento: el.consentimento.checked
          });
        });
      }).then(function (d) {
        if (!d.ok) throw new Error(d.erro || 'Não deu para enviar agora.');
        progresso(1);
        estadoEnvio(false);
        forma.hidden = true;
        obrigado.hidden = false;
        obrigado.focus({ preventScroll: true });
        F.querySelector('.mav-f__cx').scrollTop = 0;
      }).catch(function (err) {
        estadoEnvio(false);
        erro(err.message || 'Não deu para enviar agora. Tente de novo.');
        erroEl.scrollIntoView({ block: 'center', behavior: reduz ? 'auto' : 'smooth' });
        if (window.turnstile && robo.id !== null) turnstile.reset(robo.id);
      });
    });

    /* ================= começa ================= */
    if (!API || !PRODUTO) return;
    var AVALIAR = /[?&]avaliar=1\b/.test(location.search) || location.hash === '#avaliar';
    if (AVALIAR) {
      var abriuAvaliar = false;
      var abreAvaliar = function () {
        if (abriuAvaliar) return; abriuAvaliar = true;
        raiz.scrollIntoView({ block: 'start', behavior: 'auto' });
        abrirForm(null);
      };
      if (document.readyState === 'complete') setTimeout(abreAvaliar, 400);
      else window.addEventListener('load', function () { setTimeout(abreAvaliar, 400); });
    }
    /* carrega quando a seção chega perto da tela (e já de cara se a página abrir em #mk-avaliacoes) */
    var iniciou = false;
    function inicia() { if (!iniciou) { iniciou = true; carregar(false); } }
    if ('IntersectionObserver' in window && location.hash !== '#mk-avaliacoes' && !AVALIAR) {
      var obs = new IntersectionObserver(function (ents) {
        if (ents.some(function (en) { return en.isIntersecting; })) { obs.disconnect(); inicia(); }
      }, { rootMargin: '600px 0px' });
      obs.observe(raiz);
      /* as estrelas do topo da página precisam do resumo cedo: busca logo depois do carregamento */
      if (document.querySelector('[data-mav-topo]')) {
        if (document.readyState === 'complete') setTimeout(inicia, 300);
        else window.addEventListener('load', function () { setTimeout(inicia, 300); });
      }
    } else inicia();
  })();

  } catch(e) { console.error(e); }
})();
})();
